// Browser half of `wrapPageElement`. Without this file `PathContext` stays at its
// `createContext('/')` default in the browser, so `useIsChinaSite()` always returns false
// client-side — see src/wrap-page-element.js for what that breaks.
//
// Deliberately re-exports the shared implementation rather than duplicating it, so this and
// gatsby-ssr.js cannot drift apart.
exports.wrapPageElement = require('./src/wrap-page-element').wrapPageElement

// Browser half of the react-helmet-async provider — <Helmet> throws without one. Shares its
// implementation with gatsby-ssr.js; see src/wrap-root-element.js.
exports.wrapRootElement = ({ element }) =>
  require('./src/wrap-root-element').wrapWithHelmetProvider(element)
